<template>
  <div v-loading="loading">
    <el-form
      ref="form"
      :model="form"
      label-width="110px"
      id="feedback-form"
      :rules="rules"
    >
      <el-form-item label="选择车型:" prop="inputList">
        <carSearch
          @increment="appAddCounter"
          :inputList.sync="row"
          :searchType="3"
        ></carSearch>
      </el-form-item>
       <el-form-item label="指导价:" prop="special_price_max">
        <el-input v-model="form.special_price_max" @input="special_price_trueFun"></el-input>
      </el-form-item>
      <el-form-item label="降价幅度:" prop="special_discount_max">
        <el-input v-model="form.special_discount_max" @input="special_price_trueFun"></el-input>
      </el-form-item>
      <el-form-item label="优惠成交价:" prop="special_price_true">
        <el-input v-model="form.special_price_true"></el-input>
      </el-form-item>
      <el-form-item label="车源类型:" prop="special_case">
        <el-input v-model="form.special_case"></el-input>
      </el-form-item>
      <!-- <el-form-item label="车源所在地:" prop="special_source">
        <el-input v-model="form.special_source"></el-input>
      </el-form-item> -->
      <el-form-item label="手续:" prop="special_procedure">
        <el-input v-model="form.special_procedure"></el-input>
      </el-form-item>
      <el-form-item label="销售人员:" prop="userid" v-if="userInfo.id == 1">
        <el-select
          v-model="form.userid"
          filterable
          placeholder="销售人员"
        >
          <el-option
            v-for="item in saleList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="车源所在地:" prop="cityid">
        <el-select
          v-model="form.cityid"
          filterable
          placeholder="车源所在地"
        >
          <el-option
            v-for="item in cityList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="车型颜色:" prop="special_color">
        <el-input v-model="form.special_color"></el-input>
      </el-form-item>
      <el-form-item label="排序:" prop="sort" v-if="userInfo.id == 1">
        <el-input v-model="form.sort" placeholder="0在前面正序排列" type="number"></el-input>
      </el-form-item>
      <el-form-item label="备注:" prop="remark">
        <el-input v-model="form.remark"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit('form')">提交</el-button>
        <el-button @click="close(2)">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  getUserList,
  car_city
} from "../../api/api";
import carSearch from "../../components/car-search/car-search";
export default {
  name: "car-special-offer-form",
  components: {
    carSearch,
  },
  props: {
    layerid: String,
    edit: Boolean,
    seriesid: Number,
    row: {
      default: function () {
        return [];
      },
    },
  },
  data() {
    let data = {
      form: {
        cityid: "",
        brandid: "",
        seriesid: "",
        modelid: "",
        sale: "", // 销售人员
      },
      loading: false,
      rules: {
        modelid: [{ required: true, message: "请选择车系", trigger: "change" }],
        special_price_true: [
          { required: true, message: "优惠成交价", trigger: "blur" },
        ],
        special_discount_max: [
          { required: true, message: "降价幅度", trigger: "blur" },
        ],
        special_price_max: [
          { required: true, message: "指导价", trigger: "blur" },
        ],
        
      },
      options: [],
      inputList: [],
      saleList: [], // 销售人员
      cityList: [], // 城市列表
      userInfo: '',
    };
    return data;
  },
  mounted() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    if (this.seriesid) this.form.seriesid = this.seriesid;
    if (this.edit) {
      this.form = this.row
    }
    // console.log("userInfo",this.userInfo)
    this.getList();
    this.car_city();
  },
  methods: {
    special_price_trueFun(){
      if(this.form.special_price_max && this.form.special_discount_max){
        this.form.special_price_true = Number(this.form.special_price_max - this.form.special_discount_max).toFixed(2)
      }else if(this.form.special_price_max){
         this.form.special_price_true = Number(this.form.special_price_max - 0).toFixed(2)
      }
    },
    car_city(){
      car_city({
        pagesize: 999
      }).then((msg)=>{
        let { data } = msg;
        data = JSON.parse(data).data.data;
        this.cityList = data;
        console.log("msg",data);
      })
    },
    getList() {
      getUserList().then((msg) => {
        let { data } = msg;
        data = JSON.parse(data).data;
        this.saleList = data;
      });
    },
    onSubmit(e) {
      this.form.type = 1; //手动上传数据
      let data = this.form;
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if(!data.userid){
            data.userid = this.userInfo.id;
          }
          // audit_type 没有 就默认 0 
          if(!data.audit_type){
            data.audit_type = 0;
          }
          this.$emit("emincarofer",{form:data})
        } else {
          this.$message.error("请检查表单完整性");
          return false;
        }
      });
    },
    close() {
      this.$emit("emincarofer",{})
    },
    appAddCounter: function (e) {
      console.log("子组件传的值：",e);
      this.form.brandid = e["brandid"];
      if (e["seriesid"])
        this.form.seriesid = e["seriesid"] ? e["seriesid"] : "";
      if (e["modelid"]) this.form.modelid = e["modelid"] ? e["modelid"] : "";
    }
  },
  watch: {},
};
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}
</style>
<style>
.el-cascader--small {
  width: 100% !important;
}
</style>
